import { NumberInput, Text } from '@mantine/core';
import { hasKnowledgeIngest } from '../../../helpers/knowledgeIngest';
import BrowserStepsEditor from '../../KnowledgeBase/BrowserStepsEditor';
import ConsentProvidersEditor from '../../KnowledgeBase/ConsentProvidersEditor';
import HelpPopover from '../../HelpPopover/HelpPopover';
import SettingRow from '../../SettingRow/SettingRow';
import { HELP, applyExample } from './superAdminHelp';

const KnowledgeSection = ({ chatBot, handleChange }) => {
  const knowledgeIngest = chatBot.knowledgeIngest;
  // One list at a time; ChatBotPage.handleChange merges the patch, like `appearance`.
  const changeKnowledgeIngest = (patch) => handleChange({ target: { name: 'knowledgeIngest', value: patch } });

  return (
    <>
      {hasKnowledgeIngest(knowledgeIngest) ? (
        <>
          <SettingRow label="Consent banner providers" top help={<HelpPopover {...HELP.consentProviders} />}>
            <ConsentProvidersEditor
              key={chatBot.id}
              providers={knowledgeIngest.consentProviders}
              onChange={(consentProviders) => changeKnowledgeIngest({ consentProviders })}
            />
          </SettingRow>

          <SettingRow label="Browser steps" top help={<HelpPopover {...HELP.browserSteps} />}>
            <BrowserStepsEditor
              steps={knowledgeIngest.browserSteps}
              onChange={(browserSteps) => changeKnowledgeIngest({ browserSteps })}
            />
          </SettingRow>
        </>
      ) : (
        <Text size="xs" c="dimmed" py="xs">
          Knowledge base import settings are not available from the API yet.
        </Text>
      )}

      <SettingRow
        label="Documents in Store section"
        htmlFor="documentsNumber"
        help={
          <HelpPopover
            {...HELP.documentsNumber}
            onUse={applyExample(handleChange, 'documentsNumber', chatBot.documentsNumber)}
          />
        }
      >
        <NumberInput
          id="documentsNumber"
          name="documentsNumber"
          size="xs"
          w={120}
          value={chatBot.documentsNumber || ''}
          min={0}
          max={50}
          placeholder="5"
          onChange={(value) => handleChange({ target: { name: 'documentsNumber', value: value === '' ? 5 : value } })}
        />
      </SettingRow>
    </>
  );
};

export default KnowledgeSection;
